module.exports = __webpack_public_path__ + "img/partner9.383e5103.png";